var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ActivityItem,{attrs:{"id":_vm.id,"icon":_vm.icon,"indicator":_setup.totalUnreadCount,"is-active":_vm.isActive,"title":_vm.title,"tooltip":_setup.tooltip},on:{"click":function($event){return _setup.emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }